import { render, staticRenderFns } from "./GetResponse.vue?vue&type=template&id=6c00cb64&scoped=true&"
import script from "./GetResponse.vue?vue&type=script&lang=js&"
export * from "./GetResponse.vue?vue&type=script&lang=js&"
import style0 from "./GetResponse.vue?vue&type=style&index=0&id=6c00cb64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00cb64",
  null
  
)

export default component.exports